import { AlertCircle, LoaderCircle, RotateCcw } from "lucide-react";

export function LoadingState({ label = "Encendiendo esta ventana…" }: { label?: string }) {
  return (
    <div className="state-page" role="status">
      <LoaderCircle className="spin" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="state-page state-error" role="alert">
      <AlertCircle aria-hidden="true" />
      <h1>Esta ventana no abrió</h1>
      <p>{message}</p>
      {onRetry && (
        <button className="button button-light" type="button" onClick={onRetry}>
          <RotateCcw aria-hidden="true" /> Volver a intentar
        </button>
      )}
    </div>
  );
}

export function InlineNotice({ children, tone = "info" }: { children: React.ReactNode; tone?: "info" | "error" | "success" }) {
  return <div className={`inline-notice notice-${tone}`}>{children}</div>;
}
